/**
 * Handles clicks on .customer-reviews elements to scroll and open the customer reviews accordion
 */
(function customerReviewsToggle() {
  /**
   * @param {HTMLElement | null} activeDetails
   */
  function closeOtherAccordions(activeDetails) {
    if (!activeDetails) return;

    const allDetails = document.querySelectorAll('details[open]');
    allDetails.forEach((detailsEl) => {
      if (detailsEl !== activeDetails) {
        detailsEl.removeAttribute('open');
      }
    });
  }

  function openCustomerReviewsAccordion() {
    const customerReviewsDetails = document.getElementById('customer-reviews');
    if (!customerReviewsDetails) return false;

    // Close any other open accordions
    closeOtherAccordions(customerReviewsDetails);

    // Check if the details element is open
    if (!customerReviewsDetails.hasAttribute('open')) {
      // Find the summary element and click it to open
      const summaryElement = customerReviewsDetails.querySelector('summary');
      if (summaryElement) {
        summaryElement.click();
        return true;
      }
    }
    return false;
  }

  function openQuestionAnswersAccordion() {
    const qaDetails = document.getElementById('question-and-answers');
    if (!qaDetails) return false;

    // Close any other open accordions
    closeOtherAccordions(qaDetails);

    if (!qaDetails.hasAttribute('open')) {
      const summaryElement = qaDetails.querySelector('summary');
      if (summaryElement) {
        summaryElement.click();
        return true;
      }
    }
    return false;
  }

  /**
   * @param {Event} event
   */
  function handleCustomerReviewsClick(event) {
    if (!(event.target instanceof Element)) return;
    
    const target = event.target.closest('.jdgm-prev-badge__stars') || event.target.closest('.jdgm-prev-badge__text')|| event.target.closest('.customer-reviews') || event.target.closest('[data-average-rating="0.00"]');
    if (!target) return;
    
    // Find the customer reviews accordion
    const customerReviewsDetails = document.getElementById('customer-reviews');
    if (!customerReviewsDetails) return;

    // If the click is inside the already-open accordion, do nothing
    if (customerReviewsDetails.hasAttribute('open') && customerReviewsDetails.contains(event.target)) {
      return;
    }
    
    // Prevent default anchor behavior if it's a link
    if (target.tagName === 'A') {
      event.preventDefault();
    }

    // Scroll to the accordion
    customerReviewsDetails.scrollIntoView({ behavior: 'smooth', block: 'start' });

    // Wait a bit for scroll to start, then check if accordion is open
    setTimeout(() => {
      openCustomerReviewsAccordion();
    }, 100);
  }

  /**
   * @param {Event} event
   */
  function handleQuestionAnswersClick(event) {
    if (!(event.target instanceof Element)) return;

    const target = event.target.closest('.jdgm-qa-badge');
    if (!target) return;

    const qaDetails = document.getElementById('question-and-answers');
    if (!qaDetails) return;

    // If the click is inside the already-open accordion, do nothing
    if (qaDetails.hasAttribute('open') && qaDetails.contains(event.target)) {
      return;
    }

    if (target.tagName === 'A') {
      event.preventDefault();
    }

    qaDetails.scrollIntoView({ behavior: 'smooth', block: 'start' });

    setTimeout(() => {
      openQuestionAnswersAccordion();
    }, 100);
  }

  // Also handle hash changes in case someone navigates directly with #customer-reviews
  function handleHashChange() {
    if (window.location.hash === '#customer-reviews') {
      const attempts = [100, 300, 500, 1000];
      attempts.forEach((delay) => {
        setTimeout(() => {
          openCustomerReviewsAccordion();
        }, delay);
      });
    } else if (window.location.hash === '#question-and-answers') {
      const attempts = [100, 300, 500, 1000];
      attempts.forEach((delay) => {
        setTimeout(() => {
          openQuestionAnswersAccordion();
        }, delay);
      });
    }
  }

  // Use MutationObserver to watch for .customer-reviews elements being added to the DOM
  function setupObserver() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node instanceof HTMLElement) { // Element node
            // Check if the added node itself has the class or attribute
            if (node.classList && node.classList.contains('customer-reviews')) {
              attachClickHandler(node);
            } else if (node.classList && node.classList.contains('jdgm-qa-badge')) {
              attachQAClickHandler(node);
            } else if (node.hasAttribute('data-average-rating') && node.getAttribute('data-average-rating') === '0.00') {
              attachClickHandler(node);
            }
            
            // Check if any child has the class or attribute
            const customerReviewsElements = node.querySelectorAll('.jdgm-prev-badge__stars, .jdgm-prev-badge__text, .customer-reviews, [data-average-rating="0.00"], .jdgm-qa-badge');
            customerReviewsElements.forEach((element) => {
              if (element instanceof HTMLElement) {
                if (element.classList.contains('jdgm-qa-badge')) {
                  attachQAClickHandler(element);
                } else {
                  attachClickHandler(element);
                }
              }
            });
          }
        });
      });
    });

    // Start observing
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    return observer;
  }

  /**
   * @param {HTMLElement} element
   */
  function attachClickHandler(element) {
    if (!(element instanceof HTMLElement)) return;
    
    // Remove any existing handler to avoid duplicates
    element.removeEventListener('click', handleCustomerReviewsClick);
    // Add click handler
    element.addEventListener('click', handleCustomerReviewsClick);
  }

  /**
   * @param {HTMLElement} element
   */
  function attachQAClickHandler(element) {
    if (!(element instanceof HTMLElement)) return;

    element.removeEventListener('click', handleQuestionAnswersClick);
    element.addEventListener('click', handleQuestionAnswersClick);
  }

  // Attach handlers to existing elements
  function attachToExistingElements() {
    // Find .customer-reviews, [data-average-rating="0.00"], .jdgm-prev-badge elements, and .jdgm-qa-badge elements
    const existingElements = document.querySelectorAll('.jdgm-prev-badge__stars, .jdgm-prev-badge__text, .customer-reviews, [data-average-rating="0.00"], .jdgm-qa-badge');
    existingElements.forEach((element) => {
      if (element instanceof HTMLElement) {
        if (element.classList.contains('jdgm-qa-badge')) {
          attachQAClickHandler(element);
        } else {
          attachClickHandler(element);
        }
      }
    });
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      attachToExistingElements();
      setupObserver();
      handleHashChange();
    });
  } else {
    attachToExistingElements();
    setupObserver();
    handleHashChange();
  }

  // Handle hash changes
  window.addEventListener('hashchange', handleHashChange);
})();